import './theme-switch.css';
import { useTheme } from '../hooks/use-theme';

interface ThemeSwitchProps {
  /** Font-size in px that scales the whole switch (≈ 2.75em wide). Default 16. */
  sz?: number;
  className?: string;
}

const RAY_ANGLES = [0, 45, 90, 135, 180, 225, 270, 315];

function SunIcon() {
  return (
    <svg className="switch__icon" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
      <g stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        {RAY_ANGLES.map((deg) => (
          <line key={deg} x1="12" y1="17" x2="12" y2="20" transform={`rotate(${deg},12,12)`} />
        ))}
      </g>
      <circle fill="currentColor" cx="12" cy="12" r="5" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg className="switch__icon" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M15.1,14.9c-3-0.5-5.5-3-6-6C8.8,7.1,9.1,5.4,9.9,4c0.4-0.8-0.4-1.7-1.2-1.4C4.6,4,1.8,7.9,2,12.5c0.2,5.1,4.4,9.3,9.5,9.5c4.5,0.2,8.5-2.6,9.9-6.6c0.3-0.8-0.6-1.7-1.4-1.2C18.6,14.9,16.9,15.2,15.1,14.9z"
      />
    </svg>
  );
}

/**
 * Sun/Moon theme switch. `checked` = dark mode.
 * Replicated faithfully from the provided design; icons inlined (no <use>/ids).
 */
export function ThemeSwitch({ sz = 16, className }: ThemeSwitchProps) {
  const { resolvedTheme, setTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';

  return (
    <label className={`switch ${className ?? ''}`} style={{ fontSize: `${sz}px` }}>
      <input
        className="switch__input"
        type="checkbox"
        role="switch"
        name="dark"
        checked={isDark}
        onChange={() => setTheme(isDark ? 'light' : 'dark')}
      />
      <SunIcon />
      <MoonIcon />
      <span className="switch__inner" />
      <span className="switch__inner-icons">
        <SunIcon />
        <MoonIcon />
      </span>
      <span className="switch__sr">Dark Mode</span>
    </label>
  );
}
